// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2_RFu","header":"PatientQuestionnaire_header__X9W-j","info":"PatientQuestionnaire_info__20m43"};